import React, { FC } from 'react';
import { Routes, Route } from 'react-router-dom';
import SEOController from 'shared/config/routeConfig/SEOContorller/SEOController';
import blogSeoMap from '../blogSeoMap';
import { blogRouteConfig } from './blogRouterConfig';

const BlogRouter: FC = () => (
  <Routes>
    {Object.values(blogRouteConfig).map(({ element, path }) => {
      const blogName = window.location.href.split('/').pop();
      const seoData = blogSeoMap[blogName as string];
      return (
        <Route key={path} element={<SEOController key={path} {...seoData} />}>
          <Route key={path} path={path} element={element} />
        </Route>
      );
    })}
  </Routes>
);

export default BlogRouter;
